import React from 'react'
import { Input, message } from 'antd'
import i18n from 'i18n'
import WorkspaceService from 'api/Workspace'
import { confirmBase, errorBase } from 'utils/ui'
import styles from './style.module.scss'

const { TextArea } = Input

// 서비스 신청(유료전환) 확인 팝업 — 앱 표준 팝업(confirmBase, om-popup-1) 사용.
// onOk 가 reject 되면 antd confirm 이 닫히지 않으므로(실패 시 팝업 유지),
// 성공 시에만 닫히고 요청 중에는 확인 버튼이 자동 loading 처리된다.
// 워크스페이스 소유자 이름은 열림과 동시에 resource-quota API 로 조회해 modal.update 로 채운다.
export function openUpgradeRequestConfirm({ workspaceName } = {}) {
  // TextArea 는 uncontrolled — 입력값은 클로저에 보관 (modal.update 리렌더에도 DOM 값 유지)
  const formState = { userMessage: '' }

  const buildContent = (ownerEmail) => (
    <div className={styles.upgradeModalBody}>
      <p className={styles.description}>{i18n.t('topBar.upgradeModal.description')}</p>
      <div className={styles.infoRow}>
        <span className={styles.label}>{i18n.t('topBar.upgradeModal.workspaceLabel')}</span>
        <span className={styles.value}>{workspaceName}</span>
      </div>
      <div className={styles.infoRow}>
        <span className={styles.label}>{i18n.t('topBar.upgradeModal.ownerLabel')}</span>
        <span className={styles.value}>{ownerEmail || '-'}</span>
      </div>
      <div className={styles.messageField}>
        <span className={styles.label}>{i18n.t('topBar.upgradeModal.messageLabel')}</span>
        <TextArea
          rows={4}
          maxLength={1000}
          placeholder={i18n.t('topBar.upgradeModal.messagePlaceholder')}
          // modal.update 리렌더로 DOM 이 교체돼도 입력값이 유지되도록 defaultValue 로 복원
          defaultValue={formState.userMessage}
          onChange={(e) => {
            formState.userMessage = e.target.value
          }}
        />
      </div>
    </div>
  )

  // 팝업이 닫힌 뒤 늦게 도착한 소유자 조회 응답이 modal.update 를 호출하지 않도록 가드
  let isClosed = false

  const modal = confirmBase({
    title: i18n.t('topBar.upgradeModal.title'),
    width: 520,
    content: buildContent(null),
    okText: i18n.t('topBar.upgradeModal.submit'),
    cancelText: i18n.t('topBar.upgradeModal.cancel'),
    okButtonProps: {
      className: 'type8 h38',
      style: { minWidth: '100px' },
      disabled: !workspaceName,
    },
    maskClosable: false,
    onCancel: () => {
      isClosed = true
    },
    onOk: async () => {
      try {
        await WorkspaceService.requestUpgrade(workspaceName || '', formState.userMessage)
        message.success(i18n.t('topBar.upgradeModal.successMessage'))
        isClosed = true
      } catch (e) {
        errorBase({
          title: i18n.t('topBar.upgradeModal.errorTitle'),
          content: i18n.t('topBar.upgradeModal.errorMessage'),
        })
        throw e
      }
    },
  })

  // 워크스페이스 소유자 이메일 지연 로드 — 실패해도 팝업 동작엔 영향 없음('-' 유지)
  WorkspaceService.getResourceQuota()
    .then((res) => {
      const ownerEmail = res?.data?.owner_email
      if (ownerEmail && !isClosed) modal.update({ content: buildContent(ownerEmail) })
    })
    .catch(() => {})

  return modal
}

export default openUpgradeRequestConfirm
